import { Space, Button, Alert, Divider } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { useReset } from "@/hooks/queries/user/useReset";
import { useSidePanel } from "@/modules/side-panel";

const Reset = ({ user }) => {
  const { t } = useTranslation();
  const { closeSidePanel } = useSidePanel();

  const { id, name } = user;
  const mutation = useReset(id);

  const onReset = () => {
    mutation.mutate(null, {
      onSuccess: function () {
        closeSidePanel();
      },
    });
  };

  return (
    <Space orientation="vertical">
      <Alert title={t("user:resetMFA.info", { name })} type="info" />
      <Divider />
      <Space>
        <Button onClick={closeSidePanel}>{t("global:cancel")}</Button>
        <Button onClick={onReset} loading={mutation.isPending} type="primary">
          {t("global:reset")}
        </Button>
      </Space>
    </Space>
  );
};

Reset.propTypes = {
  user: PropTypes.object.isRequired,
};

export default Reset;
